export const RevenueSource = {
	ALL: "all",
	ORDERS: "orders",
	WEEKLY_STORAGE: "weekly_storage",
};
